export const R = {
	"Name1": "this is my long string",
	"Bitmap1": "[base64 mime encoded serialized .NET Framework object]",
	"Icon1": "[base64 mime encoded string representing a byte array form of the .NET Framework object]",
	"CaregiverRoleEnum_AllergyDoctor": "The doctor",
	"CaregiverRoleEnum_Dentist": "The dentist",
	"CaregiverRoleEnum_Dermatologist": "The dermatologist",
	"CaregiverRoleEnum_Doctor": "The family doctor",
	"CaregiverRoleEnum_Midwife": "The midwife",
	"CaregiverRoleEnum_Nurse": "The nurse",
	"CaregiverRoleEnum_Physiotherapist": "The physiotherapist",
	"CaregiverRoleEnum_Psychologist": "The psychologist",
	"CaregiverRoleEnum_Rheumatologist": "The rheumatologist",
	"CaregiverRoleEnum_SundVaegtDoctor": "The SundVægt doctor",
	"CaregiverRoleEnum_SundVaegtNurse": "The SundVægt nurse",
	"CaregiverRoleEnum_Dietitian": "The dietitian",
	"CaregiverRoleEnum_AcneDermatologist": "The dermatologist",
	"CaregiverRoleEnum_Veterinarian": "The veterinarian",
	"CaregiverRoleEnum_AllergyDoctor_Indefinite": "Doctor",
	"CaregiverRoleEnum_Dentist_Indefinite": "Dentist",
	"CaregiverRoleEnum_Dermatologist_Indefinite": "Dermatologist",
	"CaregiverRoleEnum_Doctor_Indefinite": "Family doctor",
	"CaregiverRoleEnum_Midwife_Indefinite": "Midwife",
	"CaregiverRoleEnum_Nurse_Indefinite": "Nurse",
	"CaregiverRoleEnum_Physiotherapist_Indefinite": "Physiotherapist",
	"CaregiverRoleEnum_Psychologist_Indefinite": "Psychologist",
	"CaregiverRoleEnum_Rheumatologist_Indefinite": "Rheumatologist",
	"CaregiverRoleEnum_SundVaegtDoctor_Indefinite": "SundVægt doctor",
	"CaregiverRoleEnum_SundVaegtNurse_Indefinite": "SundVægt nurse",
	"CaregiverRoleEnum_Dietitian_Indefinite": "Dietitian",
	"CaregiverRoleEnum_AcneDermatologist_Indefinite": "Dermatologist",
	"CaregiverRoleEnum_Veterinarian_Indefinite": "Veterinarian",
	"ConsultationPaymentProviderEnum_ApplePay": "App Store",
	"ConsultationPaymentProviderEnum_Company": "Company",
	"ConsultationPaymentProviderEnum_Coupon": "Coupon",
	"ConsultationPaymentProviderEnum_DIBS": "Pay per use",
	"ConsultationPaymentProviderEnum_ePay": "Pay per use",
	"ConsultationPaymentProviderEnum_GoogleWallet": "Google Play",
	"ConsultationPaymentProviderEnum_GracePeriod": "Grace period",
	"ConsultationPaymentProviderEnum_ReepayCheckout": "Pay per use",
	"ConsultationPaymentProviderEnum_Repay": "Pay per use",
	"ConsultationPaymentProviderEnum_Subscription": "Subscription",
	"ConsultationPaymentProviderEnum_PriceOverride": "-",
	"ConsultationTypeEnum_AllergyCheckVideo": "Allergy check",
	"ConsultationTypeEnum_DentistMessage": "Dentist email",
	"ConsultationTypeEnum_DentistVideo": "Dentist video",
	"ConsultationTypeEnum_DermatologistMessage": "Dermatologist message",
	"ConsultationTypeEnum_DermatologistVideo": "Dermatologist video",
	"ConsultationTypeEnum_Message": "Family doctor message",
	"ConsultationTypeEnum_MidwifeMessage": "Midwife message",
	"ConsultationTypeEnum_MidwifeVideo": "Midwife video",
	"ConsultationTypeEnum_NurseMessage": "Nurse message",
	"ConsultationTypeEnum_NurseVideo": "Nurse video",
	"ConsultationTypeEnum_PhysiotherapistStartupVideo": "Physiotherapist startup video",
	"ConsultationTypeEnum_PhysiotherapistMessage": "Physiotherapist: Text consultation",
	"ConsultationTypeEnum_Prescription": "Prescription renewal",
	"ConsultationTypeEnum_PsychologistVideo": "Psychologist video",
	"ConsultationTypeEnum_PsychologistCrisisVideo": "Crisis counseling",
	"ConsultationTypeEnum_RheumatologistVideo": "Rheumatologist video",
	"ConsultationTypeEnum_SundVaegtStartupMessage": "SundVægt startup",
	"ConsultationTypeEnum_SundVaegtNurseCheckupVideo": "SundVægt checkup",
	"ConsultationTypeEnum_Video": "Family doctor video",
	"ConsultationTypeEnum_DietitianStartupVideo": "Video consultation - dietitian startup",
	"PlanInterval_Day": "Daily",
	"PlanInterval_Month": "Monthly",
	"PlanInterval_Week": "Weekly",
	"PlanInterval_Year": "Annual",
	"ServiceTypeEnum_AllergyCheck": "Allergy check: Video consultation",
	"ServiceTypeEnum_DermatologistMessage": "Dermatologist: Text consultation",
	"ServiceTypeEnum_DermatologistMessageReply": "Dermatologist: Reply to text consultation",
	"ServiceTypeEnum_DermatologistVideo": "Dermatologist: Video consultation",
	"ServiceTypeEnum_Message": "Doctor: Text consultation",
	"ServiceTypeEnum_MessageReply": "Doctor: Reply to text consultation",
	"ServiceTypeEnum_PhysiotherapistStartupVideo": "Physiotherapist: Startup video consultation",
	"ServiceTypeEnum_PhysiotherapistMessage": "Physiotherapist: Text consultation",
	"ServiceTypeEnum_PhysiotherapistMessageReply": "Physiotherapist: Reply to text consultation",
	"ServiceTypeEnum_Prescription": "Doctor: Prescription renewal",
	"ServiceTypeEnum_PsychologistVideo": "Psychologist: Video consultation",
	"ServiceTypeEnum_PsychologistCrisisVideo": "Crisis counseling: Video consultation",
	"ServiceTypeEnum_RheumatologistVideo": "Rheumatologist: Video consultation",
	"ServiceTypeEnum_SundVaegtStartupMessage": "SundVægt startup",
	"ServiceTypeEnum_VideoConsultation": "Doctor: Video consultation",
	"ServiceTypeEnum_AllergyCheckVideo": "Allergy check",
	"ServiceTypeEnum_DietitianStartupVideo": "Dietitan: Startup video consultation",
	"UserTypeEnum_Admin": "Admin",
	"UserTypeEnum_Doctor": "Caregiver",
	"UserTypeEnum_Patient": "Patient",
	"ConsultationTypeEnum_SundVaegtDoctorCheckupVideo": "SundVægt doctor: Video consultation",
	"ServiceTypeEnum_SundVaegtDoctorCheckupVideo": "SundVægt doctor: Video consultation",
	"ServiceTypeEnum_SundVaegtNurseCheckupVideo": "SundVægt: Checkup video consultation",
	"ConsultationTypeEnum_SundVaegtNurseCheckupMessage": "SundVægt: Text consultation",
	"ServiceTypeEnum_SundVaegtNurseCheckupMessage": "SundVægt: Text consultation",
	"ServiceTypeEnum_SundVaegtNurseCheckupMessageReply": "SundVægt: Reply to text consultation",
	"ServiceTypeEnum_SundVaegtQuestionnaireMessageReply": "SundVægt: Questionnaire reply",
	"ConsultationTypeEnum_SundVaegtNurseAdHocVideo": "SundVægt checkup",
	"ServiceTypeEnum_SundVaegtNurseAdHocVideo": "SundVægt: Ad hoc video",
	"ConsultationTypeEnum_SundVaegtQuestionnaireMessage": "SundVægt: Questionnaire",
	"ServiceTypeEnum_SundVaegtQuestionnaireMessage": "SundVægt: Questionnaire",
	"ConsultationTypeEnum_PhysiotherapistCheckupVideo": "Physiotherapist checkup video",
	"ServiceTypeEnum_PhysiotherapistCheckupVideo": "Physiotherapist: Checkup video consultation",
	"ConsultationTypeEnum_PhysiotherapistQuestionnaireMessage": "Physiotherapist questionnaire",
	"ServiceTypeEnum_PhysiotherapistQuestionnaireMessage": "Physiotherapist: questionnaire",
	"ServiceTypeEnum_SundVaegtStartupMessageReply": "SundVægt: Startup reply",
	"SubscriptionStatusEnum_Active": "Active",
	"SubscriptionStatusEnum_Canceled": "Canceled",
	"SubscriptionStatusEnum_Expired": "Expired",
	"SubscriptionStatusEnum_PastDue": "Past due",
	"SubscriptionStatusEnum_Trialing": "Free trial",
	"SubscriptionStatusEnum_Unknown": "Unknown",
	"ConsultationTypeEnum_DietitianCheckupVideo": "Dietitian: Video follow up",
	"ServiceTypeEnum_DietitianCheckupVideo": "Dietitian: Video follow up",
	"ServiceTypeEnum_DietitianVideo": "Dietitian: Video consultation",
	"AllergyCheckVideo": "Allergy check video",
	"ConsultationTypeEnum_AllergyCheck": "Allergy check",
	"ConsultationTypeEnum_PersonalHealthProgrammeStartup": "Personal health programme startup",
	"ServiceTypeEnum_PersonalHealthProgrammeStartup": "Personal health programme startup",
	"ConsultationTypeEnum_AcneProgrammeStartupMessage": "Acne programme startup",
	"ConsultationTypeEnum_AcneProgrammeStartupVideo": "Acne programme video startup",
	"ConsultationTypeEnum_AcneProgrammeCheckupVideo": "Acne programme video checkup",
	"ServiceTypeEnum_AcneProgrammeStartupMessage": "Acne programme startup",
	"ServiceTypeEnum_AcneProgrammeStartupVideo": "Acne programme video startup",
	"ServiceTypeEnum_AcneProgrammeCheckupVideo": "Acne programme video checkup",
	"ConsultationTypeEnum_AcneDermatologistMessage": "Dermatologist message",
	"ServiceTypeEnum_AcneDermatologistMessage": "Dermatologist: Text consultation",
	"ServiceTypeEnum_AcneDermatologistMessageReply": "Dermatologist: Reply to text consultation",
	"ServiceTypeEnum_VeterinarianVideo": "Veterinarian: Video consultation",
	"ConsultationPaymentProviderEnum_Free": "Free of charge",
	"ConsultationTypeEnum_VeterinarianVideo": "Video consultation - veterinarian",
	"PetSex_Female": "Female",
	"PetSex_FemaleSterilized": "Female sterilized",
	"PetSex_Male": "Male",
	"PetSex_MaleNeutered": "Male neutered",
	"PetSex_Unknown": "Unknown",
	"PetType_Dog": "Dog",
	"PetType_Cat": "Cat",
	"PetType_Rabbit": "Rabbit",
	"PetType_Rodent": "Rodent",
	"VetConsultationReasonEnum_Gastrointestinal": "Gastrointestinal",
	"VetConsultationReasonEnum_SkinCoatEars": "Skin, coat and ears (incl. wounds and anal glands)",
	"VetConsultationReasonEnum_Poisoning": "Poisoning",
	"VetConsultationReasonEnum_Eyes": "Eyes",
	"VetConsultationReasonEnum_UrinaryTract": "Urinary tract",
	"VetConsultationReasonEnum_Lameness": "Lameness",
	"VetConsultationReasonEnum_RespiratoryTract": "Respiratory tract",
	"VetConsultationReasonEnum_OralCavity": "Oral cavity and teeth",
	"VetConsultationReasonEnum_Pain": "Pain/fever/lethargy",
	"VetConsultationReasonEnum_Claws": "Claws",
	"VetConsultationReasonEnum_GenitalsMammaryGlands": "Genitals and mammary glands",
	"VetConsultationReasonEnum_ReproductionCycle": "Reproduction and cycle",
	"VetConsultationReasonEnum_Behaviour": "Behaviour",
	"VetConsultationReasonEnum_Prescription": "Prescription",
	"VetConsultationReasonEnum_OtherReason": "Other",
	"VetConsultationOutcomeEnum_AdvisedForHomeTreatment": "Advised for home treatment (including cases not requiring treatment)",
	"VetConsultationOutcomeEnum_ReferredDuringRegularOpeningHours": "Referred during regular opening hours",
	"VetConsultationOutcomeEnum_ReferredOutsideRegularOpeningHours": "Referred outside regular opening hours"
}